export const GETTING_STARTED_PANEL_ID = 'jiraServicedeskGettingStartedPanel';
export const RIGHT_SIDE_PANEL_WIDTH = 320;
export const TRANSITION_DURATION_MS = 220;

export const PACKAGE_NAME = 'jiraServicedeskGettingStartedPanel';

export const TEAM = 'team';
export const GETTING_STARTED_PANEL_LIST_KEY = 'jsm-getting-started-panel';
export const CLOUD_ID = 'cloudid';
